class HeaderServiceMenu {
	constructor(elem) {
		// strip jQuery with [0]
		this.elem = elem[0];

		// on reused page?
		var isReusedPage = document.body.classList.contains('reused');

		// on search page?
		this.htmlNode = document.querySelector('html');
		this.searchForm = this.htmlNode.querySelector('.search-form-page');

		this.searchButton = this.elem.querySelector('[js-menu-search]');
		this.searchFieldDialog = document.querySelector('[js-header-search-dialog]');

		if (!isReusedPage) {
			this.init();
		}
	}

	init() {
		this.searchFieldDialog && document.addEventListener('click', (e) => this.onClickOutside(e));
		document.addEventListener('keydown', (e) => e.key === 'Escape' && this.closeDialog());

		!this.searchForm
			? this.searchButton?.addEventListener('click', () => this.onSearchButtonClick())
			: this.searchButton?.addEventListener('click', () => this.searchForm.querySelector('input').focus());
	}

	onSearchButtonClick() {
		return this.searchFieldDialog.open ? this.closeDialog() : this.openDialog();
	}

	onClickOutside(e) {
		if (this.searchFieldDialog.open && !e.target.closest('[js-menu-search]') && !e.target.closest('[js-header-search-dialog]')) {
			this.closeDialog();
		}
	}

	closeDialog() {
		this.searchFieldDialog.classList.add('-animate-close');
		this.searchFieldDialog.ariaHidden = true;
		this.searchButton.classList.remove('-active');
		this.searchButton.querySelector('i')?.classList.remove('close');
		this.searchFieldDialog.close();

		return setTimeout(() => {
			this.searchFieldDialog.classList.remove('-animate-close');
			this.searchFieldDialog.removeAttribute('aria-hidden');
		}, 150);
	}

	openDialog() {
		this.searchFieldDialog.show();
		this.searchButton.classList.add('-active');
		this.searchButton.querySelector('i')?.classList.add('close');
		this.searchFieldDialog.querySelector('input').focus();
	}
}

export default HeaderServiceMenu;